import apiClient from '$utils/apiClient';

const BASE_URL = '/lti/providers';

// eslint-disable-next-line import/prefer-default-export
export const getLtiProviders = async () => {
  const { data: providers } = await apiClient.get(BASE_URL, {
    withCredentials: true,
  });

  return providers;
};
